var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 16.933 16.933",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.4779 13.449h5.6733v2.9556h-9.3691v-2.9556l4.7061-5.0236c.42024-.45955.7311-.90868.93259-1.3473.20148-.43865.30222-.89469.30223-1.3682-1.06e-5-.73104-.20437-1.3194-.61309-1.765-.40298-.44561-.94123-.66836-1.6148-.66842-.51811 5.29e-5-1.0851.13581-1.7011.40733-.61597.26458-1.2751.66148-1.9774 1.1906v-3.4256c.74837-.2994 1.4881-.5257 2.2192-.67889.7311-.16013 1.4478-.24019 2.1501-.24024 1.5428 5.292e-5 2.7402.41084 3.5922 1.2325.85774.82158 1.2866 1.967 1.2866 3.4361-5e-6.84942-.18135 1.6432-.54401 2.3812-.36269.73112-1.1255 1.7128-2.2883 2.9453l-2.7546 2.9243",
    fill: "#f00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.c7946ea61bbafa85ee413e0c5379dc04.svg";
export { ForwardRef as ReactComponent };